export default {
    alt: "/static/mp3/alt.mp3", //提示按Alt+0开启工具栏
    shift1: "/static/mp3/shift1.mp3",//提示shift+0朗读工具栏
    shift2: "/static/mp3/shift2.mp3",//提示shift+z朗读工具栏
    intordus: "/static/mp3/wzatool_intordus.mp3",//朗读工具栏
    description: "/static/mp3/wzatool_description.mp3",//朗读工具栏
    swf: "/static/swf/soundmanager.swf",//soundmanager2Flash路径
    batchUrl: "http://voice.yunmd.net/ws/batch",//无障碍云批量转换路径
    // batchUrl: "https://www.yunmd.net/ws/batch",
    ajaxUrl: "http://voice.yunmd.net/ws/textToSound", //转MP3
    // ajaxUrl: "https://www.yunmd.net/ws/textToSound",
    
    // baidUrl: "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&",  可能是接口失效 
    baidUrl: "http://tts.youdao.com/fanyivoice?", //有道的语音转换接口    
    transAjaxUrl: "http://voice.yunmd.net/baidu-translate-r1.0/translate" //无障碍云翻译路径
}


// WEBPACK FOOTER //
// ./src/config/speakConfig.js